import { createMuiTheme } from '@material-ui/core';
import themeConfig from 'conf/environments';

//BLACK SELECTOR - 'rgb(235, 235, 235)'
const white = [235, 235, 235];
//BLACK SELECTOR - 'rgb(25,25,25)'
const black = [25, 25, 25];

export default env => {
    const overrideTheme = themeConfig[env] && themeConfig[env].theme;
    return createMuiTheme({
        id: env ? env : 'global',
        typography: {
            fontFamily: [
                'Source Sans Pro',
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"'
            ].join(','),
            fontSize: 14
        },
        breakpoints: {
            values: {
                xs: 0,
                sm: 425,
                md: 600,
                lg: 925,
                xl: 1280
            }
        },
        overrides: {
            MuiGrid: {
                'spacing-xs-3': {
                    margin: '0px -12px',
                    '& > $item': {
                        padding: '0px 12px'
                    }
                }
            },
            MuiTableRow: {
                root: {
                    '&:last-child td': {
                        borderBottom: 0
                    }
                }
            },
            MuiSvgIcon: {
                root: {
                    fontSize: '1.2rem'
                }
            },
            MuiTableCell: {
                root: {
                    padding: 10
                }
            },
            MuiInputBase: {
                input: {
                    '&$disabled': {
                        color: `rgba(${black}, 1)`
                    }
                }
            },
            MuiExpansionPanelDetails: {
                root: {
                    flexDirection: 'column'
                }
            },
            MuiFormLabel: {
                root: {
                    fontSize: '1.2em'
                }
            },
            MuiSelect: {
                select: {
                    '&:focus': {
                        backgroundColor: `rgba(${black}, 0)`
                    }
                }
            }
        },
        palette: {
            rainbow: {
                c001: '#e23e33',
                c002: '#d61b5b',
                c003: '#9C27B0',
                c004: '#673AB7',
                c005: '#3F51B5',
                c006: '#1b7dca',
                c007: '#0394d5',
                c008: '#00a7bd',
                c009: '#009688',
                c010: '#4CAF50',
                c011: '#709c3b',
                c012: '#a8b42e',
                c013: '#c7b529',
                c014: '#d5a106',
                c015: '#FF9800',
                c016: '#FF5722',
                c017: '#795548',
                c018: '#9E9E9E',
                c019: '#607D8B'
            },
            colors: {
                teal100: '#b6dcd3',
                teal200: '#a0d0cb',
                teal300: '#81c8bd',
                teal400: '#66bbb0',
                teal500: '#ed1c24',
                teal600: '#006e63',
                teal700: '#00594e',
                teal800: '#00524c',
                teal900: '#153e35',

                green100: '#d1debc',
                green200: '#bce094',
                green300: '#b6dd7a',
                green400: '#a3d65f',
                green500: '#81bd00',
                green600: '#62a70f',
                green700: '#638c1c',
                green800: '#497629',
                green900: '#546223',

                orange100: '#ffbfa0',
                orange200: '#ffa589',
                orange300: '#ff8e6c',
                orange400: '#ff6d37',
                orange500: '#ff4814',
                orange600: '#e14504',
                orange700: '#b73e25',
                orange800: '#993921',
                orange900: '#75391c',

                red100: '#ffb5ac',
                red200: '#ef907c',
                red300: '#eb6953',
                red400: '#e8503e',
                red500: '#e2261c',
                red600: '#cb3725',
                red700: '#ab2d2a',
                red800: '#9f3224',
                red900: '#802629',

                grey100: '#e2e2e2',
                grey200: '#bcbcbc',
                grey300: '#b2b2b2',
                grey400: '#98999b',
                grey500: '#898b8e',
                grey600: '#76777b',
                grey700: '#63656a',
                grey800: '#4a4f55',
                grey900: '#373a36',

                white: '#ffffff',
                black: '#000000'
            },
            common: {
                black: `rgba(${black}, 1)`,
                white: `rgba(${white}, 1)`
            },
            background: {
                paper: `rgba(${white}, 1)`,
                default: `rgba(${white}, 1)`
            },
            fheColors: {
                primary: {
                    light: 'rgba(210, 230, 230, 1)',
                    main: 'rgba(65, 155, 145, 1)',
                    dark: 'rgba(21, 79, 71, 1)'
                },
                secondary: {
                    light: 'rgba(210, 227, 175, 1)',
                    main: 'rgba(129, 189, 0, 1)',
                    dark: 'rgba(54, 101, 0, 1)'
                }
            },
            error: {
                light: 'rgba(237, 166, 166, 1)',
                main: 'rgb(203,33,54)',
                dark: 'rgb(122,11,11)'
            },
            warning: {
                light: 'rgb(255,243,224)',
                main: 'rgb(255,152,0)',
                dark: 'rgb(230,81,0)'
            },
            success: {
                light: 'rgb(195,241,166)',
                main: 'rgb(66,157,45)',
                dark: 'rgb(32,65,20)'
            },
            text: {
                primary: `rgba(${black}, 1)`,
                secondary: `rgba(${black}, 0.8)`,
                disabled: `rgba(${black}, 0.5)`,
                hint: `rgba(${black}, 0.4)`,
                contrastText: `rgba(${white}, 1)`
            },
            /* DEFAULT THEME START */
            primary: {
                light: 'rgba(210, 230, 230, 1)',
                main: 'rgba(65, 155, 145, 1)',
                dark: 'rgba(21, 79, 71, 1)'
            },
            secondary: {
                light: 'rgba(210, 227, 175, 1)',
                main: 'rgba(129, 189, 0, 1)',
                dark: 'rgba(54, 101, 0, 1)'
            },
            /* DEFAULT THEME END */
            ...(overrideTheme && overrideTheme.palette ? overrideTheme.palette : null)
        },
        shape: {
            borderRadius: 8
        }
    });
};



// WEBPACK FOOTER //
// ./data/common/uiTheme.js